import { Switch, Route } from 'react-router-dom';

import Layout from '../pages/_layout';
import { Home } from '../pages/Home';
import { Debito } from '../pages/Debito';
import { Pagamento } from '../pages/Pagamento';
import { PagamentosRealizados } from '../pages/PagamentosRealizados';

function Routes() {
  return (
    <Layout>
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/debito" exact component={Debito} />
        <Route path="/pagamento" exact component={Pagamento} />
        <Route
          path="/pagamentos-realizados"
          exact
          component={PagamentosRealizados}
        />
        <Route path="/:token" component={Home} />
      </Switch>
    </Layout>
  );
}

export default Routes;
